var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.0007 64.1666C51.109 64.1666 64.1673 51.1082 64.1673 34.9999C64.1673 18.8916 51.109 5.83325 35.0007 5.83325C18.8923 5.83325 5.83398 18.8916 5.83398 34.9999C5.83398 51.1082 18.8923 64.1666 35.0007 64.1666Z",
    fill: "url(#paint0_linear_3220_4516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40.1041C36.1958 40.1041 37.1875 39.1124 37.1875 37.9166V23.3333C37.1875 22.1374 36.1958 21.1458 35 21.1458C33.8042 21.1458 32.8125 22.1374 32.8125 23.3333V37.9166C32.8125 39.1124 33.8042 40.1041 35 40.1041Z",
    fill: "url(#paint1_linear_3220_4516)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.684 45.5584C37.5382 45.2084 37.334 44.8876 37.0715 44.5959C36.7798 44.3334 36.459 44.1292 36.109 43.9834C35.409 43.6917 34.5923 43.6917 33.8923 43.9834C33.5423 44.1292 33.2215 44.3334 32.9298 44.5959C32.6673 44.8876 32.4632 45.2084 32.3173 45.5584C32.1715 45.9084 32.084 46.2876 32.084 46.6667C32.084 47.0459 32.1715 47.4251 32.3173 47.7751C32.4632 48.1542 32.6673 48.4459 32.9298 48.7376C33.2215 49.0001 33.5423 49.2042 33.8923 49.3501C34.2423 49.4959 34.6215 49.5834 35.0007 49.5834C35.3798 49.5834 35.759 49.4959 36.109 49.3501C36.459 49.2042 36.7798 49.0001 37.0715 48.7376C37.334 48.4459 37.5382 48.1542 37.684 47.7751C37.8298 47.4251 37.9173 47.0459 37.9173 46.6667C37.9173 46.2876 37.8298 45.9084 37.684 45.5584Z",
    fill: "url(#paint2_linear_3220_4516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3220_4516",
    x1: 5.83398,
    y1: 5.83325,
    x2: 72.6282,
    y2: 18.1016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3220_4516",
    x1: 32.8125,
    y1: 21.1458,
    x2: 37.9818,
    y2: 21.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3220_4516",
    x1: 32.084,
    y1: 43.7646,
    x2: 38.7623,
    y2: 44.9944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5332f09a344d371dea6607665102ec4f.svg";
export { ForwardRef as ReactComponent };